module.exports = __webpack_public_path__ + "media/images/e-bilet/language-22cd744ef35ae05037d39936932b3e22.svg";